module.exports = __webpack_public_path__ + "static/media/neon_linkedin.471a7345.png";